/**
 * Composant d'affichage vide pour les réservations sans review créée par le propriétaire
 * Accordion désactivé avec message explicatif
 */

import React from 'react';
import {
  Box,
  Typography,
  Accordion,
  AccordionSummary,
  AccordionDetails,
  alpha
} from '@mui/material';
import {
  ExpandMore as ExpandMoreIcon,
  RateReview as RateReviewIcon
} from '@mui/icons-material';
import { useTheme } from '@mui/material/styles';
import { useTranslation } from 'react-i18next';

/**
 * Composant OwnerCreatedReviewEmpty
 * Affiche un accordion désactivé quand aucune review créée par le propriétaire n'existe
 */
const OwnerCreatedReviewEmpty = () => {
  const theme = useTheme();
  const { t } = useTranslation('ownerReviews');

  return (
    <Accordion
      disabled
      sx={{
        borderRadius: 2,
        border: `1px solid ${theme.palette.divider}`,
        backgroundColor: alpha(theme.palette.grey[500], 0.05),
        '&:before': {
          display: 'none'
        },
        '&.Mui-disabled': {
          backgroundColor: alpha(theme.palette.grey[500], 0.05)
        }
      }}
    >
      <AccordionSummary
        expandIcon={<ExpandMoreIcon />}
        sx={{
          cursor: 'default',
          '& .MuiAccordionSummary-content': {
            alignItems: 'center',
            gap: 1
          },
          opacity: 0.6
        }}
      >
        <RateReviewIcon sx={{ color: theme.palette.text.secondary }} />
        <Typography variant="body2" color="text.secondary">
          {t('emptyReview', 'Aucune évaluation disponible')}
        </Typography>
      </AccordionSummary>
      <AccordionDetails>
        <Typography variant="body2" color="text.secondary" sx={{ fontStyle: 'italic' }}>
          {t('emptyMessage', 'Aucune évaluation n\'a été créée pour cette réservation')}
        </Typography>
      </AccordionDetails>
    </Accordion>
  );
};

export default OwnerCreatedReviewEmpty;
